import styled from 'styled-components'

interface ICardholderSelectSelectedValueStyledProps {}

export const CardholderSelectSelectedValueStyled = styled.span<ICardholderSelectSelectedValueStyledProps>`
  display: flex;
`
